import { Button, Outside } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './index.css';
import { IGetProductsParams } from '../../tracking/hide_offer';
import { ComplaintContainer } from '../complaint/container';

export interface IHiddenBlockStoreButtonsProps {
  isComplainOpened: boolean;
  productParams?: IGetProductsParams;
}

export interface IHiddenBlockDispatchButtonsProps {
  toggleComplainPopup(isOpened: boolean): () => void;
  restoreOffer(): void;
}

type IHiddenBlockButtonsProps = IHiddenBlockStoreButtonsProps & IHiddenBlockDispatchButtonsProps;

export class HiddenBlockButtons extends React.PureComponent<IHiddenBlockButtonsProps, {}> {
  public render() {
    const { isComplainOpened, toggleComplainPopup, restoreOffer } = this.props;

    return (
      <div className={styles['buttons-outer']}>
        <span className={styles['complaint-outer']}>
          <Button size="XS" onClick={toggleComplainPopup(true)} theme="fill_error_secondary">
            Пожаловаться
          </Button>
          {isComplainOpened && (
            <Outside onOutside={toggleComplainPopup(false)}>
              <div className={styles['tooltip']}>
                <ComplaintContainer handleOutsideClick={toggleComplainPopup(false)} />
              </div>
            </Outside>
          )}
        </span>
        <Button size="XS" onClick={restoreOffer} theme="fill_secondary">
          Восстановить
        </Button>
      </div>
    );
  }
}
